import { Compania } from 'src/app/shared/models/compania';
import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { defaultValueOrRangeValidator, isMobile, isMobileXL, loadData, toFormData } from 'src/app/shared/utils/helpers';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { ListaPrecioItem } from 'src/app/shared/models/listaPrecioItem';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Pais } from 'src/app/shared/models/pais';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';

@Component({
  selector: 'app-listas-precios-items-dialog',
  templateUrl: './listas-precios-items-dialog.component.html'
})
export class ListasPreciosItemsDialogComponent implements OnInit {

  mensaje: number = 0;
  form: FormGroup;
  idTipo: number;
  item: ListaPrecioItem;
  codigoEdit: number = -1;

  constructor(
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ListasPreciosItemsDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private productosService: ProductosService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,

    @Inject(MAT_DIALOG_DATA) private data: any) {
    this.form = this.fb.group({
      habilitacion: [true],
      usuarioRedUltimaActualizacion: [''],
      tasa: ['', Validators.required],
      descripcion: [''],
      idProducto: [''],
      codigo: [0]
    })

    if (data.idTipo != null) {
      this.idTipo = data.idTipo;
    }
    if (data.i != null) {
      this.codigoEdit = data.i.codigo
      this.item = data.i

    }
  }

  public Etiquetas: {

    Id: string,
    Tasa: string,
    Descripcion: string,
    Habilitacion: string,


  }

  public Validaciones: {
    Tasa: string
  }

  ngOnInit() {
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    this.Etiquetas = {

      Habilitacion: this.configService.etiquetas.Habilitacion,
      Id: this.configService.etiquetas.Codigo,
      Descripcion: this.configService.etiquetas.Descripcion,
      Tasa: this.configService.etiquetas.ListasPrecios.Items.Tasa

    }

    this.Validaciones = {
      Tasa: this.configService.validaciones.ListasPrecios.Items.Dialog.Tasa
    }

    this.productosService.cListaPrecioItemDb(this.codigoEdit).subscribe((data: ListaPrecioItem) => {
      if (data != null) {

        this.form.controls['descripcion'].setValue(this.item.descripcion);
        this.form.controls['idProducto'].setValue(data.idProducto);
        this.form.controls['habilitacion'].setValue(data.habilitacion);
        this.form.controls['tasa'].setValue(data.tasa);
        this.form.controls['codigo'].setValue(data.codigo);
        this.form.markAsUntouched();
        this.form.markAsPristine();
      }
    })
  }

  guardarItem() {

    switch (this.idTipo) {

      case 2:
        this.form.controls['usuarioRedUltimaActualizacion'].setValue(this.loggedService.logged.userName);
        this.productosService
          .mListaPrecioItem(this.form.value)
          .subscribe((data: boolean) => {
            this.mensaje = this.idTipo;
            this.dialogRef.close();
          });
        break;
    }

  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

  clearInput(formControlName: string) {
    this.form.controls[formControlName].reset();

  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

}
